export default "__VITE_ASSET__DOOfTsHn__"